import { NavLink } from "react-router-dom"
import { ProjectList } from "./ProjectList"
import { OnlineUsers } from "./OnlineUsers";
import { HomeIcon, BriefcaseIcon } from "@heroicons/react/solid";



export const Sidebar = () => {
  return (
    <aside className="bg-gray-800 text-slate-400 w-64 space-y-6 justift-start min-h-screen ">
        <nav >
            <ul>
                <li className="flex py-2.5 px-4">
                   
                    <NavLink activeClassName="text-yellow-500" className="flex justify-center items-center " exact to="/" >
                    <HomeIcon className="flex h-5 w-5 justify-center items-center mr-3" />
                        Dashbaord</NavLink>
                </li>
                <li className="flex py-2.5 px-4">
                
                    <NavLink activeClassName="text-yellow-500" className="flex justify-center items-center " to="/create" >
                    <BriefcaseIcon className="flex h-5 w-5 justify-center items-center mr-3" />
                        New Project</NavLink>
                </li >
            </ul>
        </nav>
        <ProjectList />
        <OnlineUsers className="flex justify-end" />
    </aside>
  )
}